import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faExclamationTriangle,
  faPlay,
} from '@fortawesome/free-solid-svg-icons';

const ReadinessChecksMock = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3">
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-3">
        <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2">
          Validation Readiness
        </h4>
        <div className="grid grid-cols-2 gap-2">
          {[
            { label: 'WFA passed', passed: true, detail: '2/2 windows' },
            { label: 'Stability threshold', passed: true },
            { label: 'Sample adequacy', passed: true, warning: true, detail: 'marginal' },
            { label: 'Risk classification', passed: true, detail: 'Low' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sm">
              <FontAwesomeIcon
                icon={item.warning ? faExclamationTriangle : faCheck}
                className={`w-3 h-3 ${item.warning ? 'text-amber-400' : 'text-emerald-400'}`}
              />
              <span className="text-gray-300">{item.label}</span>
              {item.detail && <span className="text-gray-500 text-xs">({item.detail})</span>}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-3">
        <div className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-cyan-600 text-white rounded-lg font-medium text-sm">
          <FontAwesomeIcon icon={faPlay} />
          Start Live Validation
        </div>
      </div>
    </div>
  </div>
);

export default ReadinessChecksMock;
